import klydoApiClient, { PopulatedKlydo } from '../../../api/klydo';
import useKlydoQuery from '../../../hooks/useKlydoQuery';

const useGetKlydoQuery = (
  klydoId: string,
  options?: { refetchInterval?: number | false },
) => {
  return useKlydoQuery<PopulatedKlydo>({
    queryKey: ['klydo', klydoId],
    queryFn: () => klydoApiClient.getKlydo(klydoId),
    enabled: !!klydoId,
    refetchInterval: options?.refetchInterval ?? 30 * 1000,
  });
};

export default useGetKlydoQuery;
